import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2/chats';

const chatsArquivoService = {
    listarDivisoes: async () => {
        const response = await axiosInstance.get(`${API_BASE}/arquivo/divisoes`);
        return response.data;
    },

    criarDivisao: async (data) => {
        const response = await axiosInstance.post(`${API_BASE}/arquivo/divisoes`, data);
        return response.data;
    },

    editarDivisao: async (divisaoId, data) => {
        const response = await axiosInstance.put(`${API_BASE}/arquivo/divisoes/${divisaoId}`, data);
        return response.data;
    },

    excluirDivisao: async (divisaoId, moverPara) => {
        const response = await axiosInstance.delete(`${API_BASE}/arquivo/divisoes/${divisaoId}`, {
            data: { mover_para: moverPara }
        });
        return response.data;
    },

    reordenarDivisoes: async (ordem) => {
        const response = await axiosInstance.put(`${API_BASE}/arquivo/divisoes/reordenar`, { ordem });
        return response.data;
    },

    listarChats: async (params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/arquivo/lista`, { params });
        return response.data;
    },

    arquivar: async (chatId, divisaoId) => {
        const response = await axiosInstance.post(`${API_BASE}/${chatId}/arquivar`, { divisao_id: divisaoId });
        return response.data;
    },

    desarquivar: async (chatId, statusDestino) => {
        const response = await axiosInstance.post(`${API_BASE}/${chatId}/desarquivar`, {
            status_destino: statusDestino
        });
        return response.data;
    },

    mover: async (chatId, divisaoId, ordem) => {
        const response = await axiosInstance.put(`${API_BASE}/${chatId}/arquivo/mover`, {
            divisao_id: divisaoId,
            ordem
        });
        return response.data;
    },

    arquivarMultiplos: async (chatIds, divisaoId) => {
        const response = await axiosInstance.post(`${API_BASE}/arquivo/arquivar-multiplos`, {
            chat_ids: chatIds,
            divisao_id: divisaoId
        });
        return response.data;
    }
};

export default chatsArquivoService;
